export default "__VITE_ASSET__OOIuuqAS__"